<div class="custom-dialog-container">
    <div class="dialog-header">
        <div class="header-text">
            <h2>{{content?.['b2b.managetraveler.verifymobileno'] || 'Verify your Mobile number'}} </h2>
            <!-- <h2>{{content?.['b2b.managetraveler.mobileno']}}</h2> -->
        </div>
        <mat-icon fontSet="material-symbols-outlined" (keydown.enter)="dialogRef.close()" tabindex="0" role="button" aria-label="close button" class="close_icon" (click)="dialogRef.close()">close</mat-icon>
    </div>
    <div class="dialog-body">
        <div class="passenger-details">
            <form class="passenger-details-form" [formGroup]="updateMobileNumber">
            <div class="twoColLayout main-content">
                <div class="passenger-info-section col">
                    <div class="passenger-document-details passengerInputSpace">
                        <!-- Only show form when toggle is checked -->
                        <div class="f-row two--ColLayout mb-4">
                            <div class="f-col">
                                <ng-select autoBlurSelect [items]="countriesLists" groupBy="group" [searchFn]="_CommonService.customCountryCodeSearchFn" formControlName="countryCode" bindValue="code" [placeholder]="'Country code'" [appendTo]="'body'">
                                    <ng-template ng-optgroup-tmp let-item="item"> {{ item.group }} </ng-template>
                                    <ng-template ng-option-tmp let-item="item">
                                        <span class="ng-option-label">
                                            @if (!!item?.newFlag?.src) {
                                                <img [src]="getImageUrl(item?.newFlag?.src)" alt="Flag of {{ item.countryName }}" class="flag-img" [height]="item.height" [width]="item.width" />
                                            }
                                            {{ item.countryName }} ({{ item?.code }})
                                        </span>
                                    </ng-template>
                                    <ng-template ng-label-tmp let-item="item">
                                        <span class="ng-value-label">
                                            @if (item?.code) {
                                                <span class="ng-disabled">{{ item?.code }}</span>
                                            }
                                        </span>
                                    </ng-template>
                                    <ng-template ng-notfound-tmp>
                                        <div class="no-items-found">
                                            <img src="assets/images/not-found.png" alt="No items found" class="no-items-image" />
                                            <p>{{ cancelFlightContent?.['b2b.mmb.nocountryfound'] }}</p>
                                        </div>
                                    </ng-template>
                                </ng-select>
                            </div>
                            <div class="f-col">
                                <mat-form-field appearance="fill">
                                    <mat-label>{{content?.['b2b.managetraveler.mobileno'] || 'Mobile Number'}}</mat-label>
                                    <input matInput formControlName="mobileNumber" [placeholder]="content?.['b2b.managetraveler.mobileno'] || 'Enter your mobile number'" (keypress)="blockInvalidCharacters($event)" (paste)="_CommonService.onPasteBlocked($event)">
                                    <mat-icon fontSet="material-symbols-outlined" matSuffix> phone_android </mat-icon>
                                    @if (updateMobileNumber.get('mobileNumber')?.hasError('required') && updateMobileNumber.get('mobileNumber')?.touched ) {
                                        <!-- <mat-error> Mobile number is required. </mat-error> -->
                                        <mat-error> {{content?.['b2b.managetraveler.enterphoneno'] || 'Mobile number is required.'}} </mat-error>
                                    }
                                    @if (updateMobileNumber.get('mobileNumber')?.hasError('pattern') && updateMobileNumber.get('mobileNumber')?.touched ) {
                                        <!-- <mat-error> Please enter a valid 10 digit mobile number. </mat-error> -->
                                        <mat-error> {{content?.['b2b.managetraveler.validatemobileno'] || 'Please enter a valid 10 digit mobile number.'}} </mat-error>
                                    }
                                    @if (updateMobileNumber.get('mobileNumber')?.hasError('minlength') && updateMobileNumber.get('mobileNumber')?.touched ) {
                                        <!-- <mat-error> Mobile number must be at least 6 digits. </mat-error> -->
                                        <mat-error> Mobile number must be at least 8 digits. </mat-error>
                                    }
                                    @if (updateMobileNumber.get('mobileNumber')?.hasError('maxlength') && updateMobileNumber.get('mobileNumber')?.touched ) {
                                        <!-- <mat-error> {{content?.['b2b.managecompany.mobilenumbermaxlimit'] || 'Mobile number cannot exceed 12 digits.'}} </mat-error> -->
                                        <mat-error>Mobile number cannot exceed 12 digits.</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            @if (!Loader.isEditableClicked) {
                <div class="dialog-footer btn-right">
                    <button mat-button type="button" class="mdc-button button--primary-small" (click)="onSave()" [class.disabled]="updateMobileNumber.invalid || Loader.isSpinner">
                        @if (Loader.isSpinner) {
                            <mat-spinner class="button"></mat-spinner>
                        }
                        {{ content?.['b2b.managetraveler.save'] || 'Save'}}
                    </button>
                </div>
            }
            </form>
        </div>
    </div>
</div>